import { Fancybox } from 'global-modules';

class QuickAdd extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.listeners = {
      openFancybox: event => this.openFancybox(event),
      handleSubmit: this.handleSubmit.bind(this),
    };

    this.querySelector('[data-quick-shop-toggle]')?.addEventListener('click', this.listeners.openFancybox);
  }

  disconnectedCallback() {
    this.querySelector('[type="submit"]')?.removeEventListener('click', this.listeners.handleSubmit);
    this.querySelector('[data-quick-shop-toggle]')?.removeEventListener('click', this.listeners.openFancybox);
  }

  handleSubmit() {
    if (this.fancyboxObj) {
      setTimeout(() => {
        this.fancyboxObj.close();
      }, 250);
    }
  }

  openFancybox(event) {
    event.currentTarget.classList.add('loading');
    event.currentTarget.setAttribute('disabled', true);
    this.trigger = event.currentTarget;

    setTimeout(() => {
      this.trigger.classList.remove('loading');
      this.trigger.removeAttribute('disabled');
    }, 250);

    this.fancybox();
  }

  fancybox() {
    if (!Fancybox) return false;

    Fancybox.show(
      [
        {
          src: this.trigger.dataset.src,
          type: 'inline',
        },
      ],
      {
        dragToClose: false,
        animated: false,
        on: {
          done: fancybox => {
            this.fancyboxObj = fancybox;
            fancybox.container.querySelector('[type="submit"]')?.addEventListener('click', this.listeners.handleSubmit);
          },
          destroy: fancybox => {
            fancybox.container.querySelector('[type="submit"]')?.removeEventListener('click', this.listeners.handleSubmit);
          },
        },
      },
    );
  }
}

if (!customElements.get('quick-shop')) {
  customElements.define('quick-shop', QuickAdd);
}
